import axios from "@/config/axiosConfig";

export const getPurchaseBillSalesBalanceFilterDetail = (params = {}) => {
    return async (dispatch, getState) => {
        try {

            const { auth } = getState();
            const defaultParams = {
                finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth.user?.Customer_Id,
            };
            const requestParams = { ...defaultParams, ...params };

            return axios.get('/stock-report/getPurchaseBillSalesBalanceDetailsOptions', { params: requestParams }).then((response) => {
                return response.data;
            }).catch((error) => {
                console.error("Error fetching order balance(bill base) Report:", error);
                throw error;
            });
        } catch (error) {
            console.error("Error fetching order balance(bill base) Report:", error);
            throw error;
        }
    };
};

export const getPurchaseBillSalesBalanceReport = (params) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const defaultParams = {
        userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const data = {
        filterType: params?.filterType,
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };

      // Make API call
      return axios.post('/stock-report/getPurchaseBillSalesBalanceReport', data, { params: defaultParams }).then((response) => {
        return response.data
        
      }).catch((error) => {
        console.error("Error fetching order balance(bill base) Report:", error);
        throw error;
      });
    } catch (error) {
      console.error("Error fetching order balance(bill base) Report:", error);
      throw error;
    }
  };
};